const e = {
  productTileMaxWidth: "10.625rem",
  productTileMinHeight: "18.1rem",
  inventoryBadgeMaxWidth: "3.625rem",
  inventoryBadgeMaxHeight: "2rem",
  heroBannerMaxHeight: "18.75rem",
  heroBannerImageHeight: "2rem",
  heroBannerVStackSm: "17rem",
  heroBannerVStackXl: "40rem",
  heroBannerSkeletonContainerHeightTablet: "18.75rem",
  heroBannerSkeletonStackSpacing: "1rem",
  bannerMaxHeight: "18.75rem",
  bannerLogoHeight: "2rem",
  bannerImageMinHeight: "10rem",
  menuTileWidth: "6.875rem",
  navTileContainerWidth: "16.752rem",
  navTileImageContMaxHeightSm: "13rem",
  navTileImageContWidthLg: "13.375rem",
  navTileTextContWidthLg: "20.75rem",
  navTiledSkeletonImageWidthMobile: "10rem",
  navTiledSkeletonImageWidthTablet: "12rem",
  navTilesSkeletonBodyWidth: "15rem",
  navTileSkeletonContainerWidth: "14rem",
  navTileSkeletonButtonWidth: "8rem",
  navTileSkeletonTitleHeight: "12rem",
  navTileSkeletonTitleMarginBottom: "0.75rem",
  navTileSkeletonButtonHeight: "3rem",
  productTileATCContHeight: "2.5rem",
  productTileSkeText1: "4rem",
  productTileSkeText2: "8rem",
  productTileSkeText3: "6rem",
  productTileSkeText4: "8rem",
  productTileSkeImg: "5rem",
  productTileSkeBadge: "2rem",
  productTileSkeBadgeRight: "0.5rem",
  productTileSkeBadgeTop: "1rem",
  productGridSkeHeadingWidth: "14rem",
  productGridSkeTextWidthBase: "20rem",
  productGridSkeTextWidthSm: "35rem",
  productGridSkeTextWidthLg: "50rem",
  atcButtonWrapperHeight: "4.5rem",
  atcIconHeight: "2.5rem",
  atcButtonHeight: "2.5rem",
  atcButtonWidth: "2.5rem",
  atcInputBoundaryBox: "3.125rem",
  stickyATCHeight: "3.625rem",
  miniProductTileMinWidth: "17.5rem",
  miniProductTileMaxWidth: "22.94rem",
  miniProductTileSkeImg: "3.75rem",
  carouselHeaderColumnGap: "0.5rem",
  scrollContainerPaddingBottom: "1rem",
  scrollContainerBottom: "-6.25rem",
  carouselHeaderSkeletonWidth: "30rem",
  carouselHeaderSkeletonSubTitleWidth: "20rem",
  carouselHeaderSkeletonLinkWidth: "5rem",
  maxHeadlineLogoHeight: "3.125rem",
  spotlightSkeletonContentHeight: "11rem",
  spotlightSkeletonButtonWidth: "6.5rem",
  sliderArrowsIconSize: "0.875rem",
  breadcrumbsSkeletonWidth: "5rem",
  filterChipContentWidth: "7rem",
  filterChipSkeletonWidth: "5rem",
  sliderPaginationBulletDiameter: "0.625rem",
  sliderPaginationBulletMargin: "0.5rem",
  // TODO: remove the following two nutrition table namespaced tokens once token sheet is updated
  nutritionTableDarkGrey: "#595959",
  nutritionTableThickBorder: "0.187rem",
  searchBarIconRightPosition: "3rem",
  topBarMinHeight: "1.5rem",
  searchBarClearIconRightPosition: "2.625rem",
  formSearchInputFieldPaddingRight: "5.25rem",
  searchBarQueryIconRightPosition: "0.625rem",
  mastheadMobileButtonWidth: "2.5rem",
  mobileTypeaheadContainerTop: "5rem",
  productDetailsSkeletonGap: "5rem",
  megaMenuV2PanelTop: "2.05rem",
  megaMenuV2L2TabsWidth: "19rem",
  megaMenuV2L2LinkTextMinHeight: "2rem",
  tabTop: "0.125rem",
  menuDoubleExtraLargeInnerSpacing: "5.35rem"
};
export {
  e as default
};
